export const locale = {
  lang: 'en',
  data: {
    phone: {
      ext: 'Ext.',
    },
    addresses: {
      title: 'Manage addresses',
      current: 'Current',
      future: 'Future',
      correctAddress: 'Correct the address',
      correctEffectiveDate: 'Correct starting date',
      no: 'No',
      yes: 'Yes',
      ok: 'Ok',
    },
    memberLocalisation: {
      residencePlace: {
        title: 'Residence',
        current: 'Current',
        comingAddressChange: 'Coming address change',
        phones: 'Phones',
        phone1: 'Phone',
        phone2: 'Phone 2',
        address: 'Addresse',
        startingOn: 'Starting on',
        endingOn: 'Ending on',
        changeResidence: 'Make an address change',
        confirmDeleteDomicileProfessional: 'Cancel the associated main practice place',
        confirmDeleteDomicileProfessionalMessage: 'This residence has been assigned as Main practice place. To cancel it, this association must also be cancelled',
        cancelResidenceChange: 'Are you sure you want to cancel the change',
        menu: {
          changeResidence: 'Change residence',
          correctResidence: 'Correct residence informations',
          correctChange: 'Correct change',
          cancelChange: 'Cancel change',
        },
        dialog: {
          addResidence: 'Add residence',
          correctResidenceChange: 'Correct the change',
          cancelResidenceChange: 'Cancel the change',
        },
        errors: {
          effectiveDateTaken: 'Another residence start at this date',
        },
      },
      professionalDomicile: {
        title: 'Professional domicile',
        current: 'Current',
        comingAddressChange: 'Coming change',
        clinic: 'Clinic',
        phone: 'Phone',
        fax: 'Fax',
        address: 'Address',
        wheelchairAccess: 'Wheelchair access',
        typeOfPractice: 'Type of practice at this address',
        isInCompany: 'Part of a company',
        professionalDomicileSince: 'Professional domicile since',
        practicePlace: 'Practice place',
        noPracticePlacesInEffect: 'No practice places are in effect at this date',
        practicePlaceSince: 'Practice place since',
        typeOfplace: 'Type de lieux',
        changeProfessionalDomicile: 'Change the professional domicile',
        cancelChange: 'Cancel the professional domicile change',
        menu: {
          correctPracticePlaceInfos: 'Correct this practice place informations',
          define: 'Change main practice place',
          correctInformation: 'Correct the address',
          correctChange: 'Correct change of practice place',
          cancelChange: 'Cancel change of practice place',
        },
        dialog: {
          correctInformation: {
            title: 'Correct professional domicile information',
            searchPlaceholder: 'Search an existing clinic or enter the name of a new one',
            clinicName: 'Clinic name',
            address: 'Address',
            phone: 'Phone',
            fax: 'Fax',
            practiceSince: 'Pratice since',
            practiceUntil: 'Practice until',
            wheelChairAccess: 'Has wheel chair access',
            practiceType: 'Practice type on the address',
            company: 'In a company',
            isAssociate: 'Is associate',
            isEmployee: 'Is employee',
            isSelfEmployed: 'Is self employed',
          },
        },
      },
      secondaryPracticePlace: {
        title: 'Other practice place',
        addPracticePlace: 'Add a practice place',
        searchPlaceholder: 'Search for an existing  or enter type its name',
        clinicName: 'Clinic',
        address: 'Address',
        phone: 'Phone',
        fax: 'Fax',
        practiceSince: 'Practice here since',
        practiceUntil: 'Practice here until',
        wheelChairAccess: 'Wheelchair access',
        practiceType: 'Type of practice',
        otherPracticeType: 'Other practice type',
        company: 'Company',
        reason: 'Reason',
        principal: 'Principal',
        nextPrincipal: 'Principal to come',
        comingPracticePlaces: 'Coming practice places',
        confirmDeleteDomicileProfessional: 'Cancel the associated main practice place',
        confirmDeleteDomicileProfessionalMessage: 'This practice place has been assigned as Main practice place. To end it, this association must also be cancelled',
        removePracticePlaceDate: 'Remove practice place',
        cannotRemoveLastWorkPlaceIfActive: 'The last practice place cannot be removed if you are still active',
        startDateAsPrincipal: 'Starting date as main practice place',
        addDialog: {
          title: 'Add a practice place',
          isCompanyAddress: 'Inside a company',
          isAssociate: 'Is associate',
          isSelfEmployed: 'Is self eemployed',
          isEmployee: 'Is employed',
          companyName: 'Company name'
        },
        correctDialog: {
          title: 'Correct a practice place',
        },
        addressChangeError:
          "You are attempting to modify an address that has been active for some time. To preserve the history of your changes:<br/><br/>1. Use \"Add a practice place\" to enter a new address.<br/><br/>2. Choose \"End this practice place\" rather than \"Correct address\" in the Edit menu, then enter an end date for this address.",
        reasonTitles: {
          isAssociate: 'Associate',
          isEmployee: 'Employee',
          isSelfEmployed: 'Self employed',
        },
        menu: {
          correctPracticePlaceInfo: 'Correct practice place informations',
          removePracticePlace: 'Remove practice place',
          removeMessage: 'Are you sure you want to remove this practice place ?',
          defineAsMainPracticePlace: 'Define as main practice place',
          cancelFutureMainPracticePlace: 'Cancel future main practice place',
          cancelFutureMainPracticePlaceMessage: 'Are you sure you want to cancel this future main practice place',
          defineAsMainPracticePlaceMessage: 'Are you sure you want to define as main practice place ?',
          correctEndDate: 'Correct the work address end date',
          correctStartDate: 'Correct the work address start date',
          cancelChange: 'Cancel practice place change',
          cancelFutureWorkplace: 'Cancel this practice place',
          cancelFutureWorkplaceMessage: 'Are you sure you want to cancel this practice place ?',
          cancelEndDate: 'Cancel the work address end date',
          cancelEndDateMessage: 'Are you sure you want to cancel the end date ?',
        },
      },
      correspondencePlace: {
        title: 'Postal address',
        subTitle: 'Address where the <i>Ordre des dentistes du Québec</i> should send correspondence.',
        current: 'Current',
        phone1: 'Phone',
        phone2: 'Phone 2',
        phones: 'Phones',
        fax: 'Fax',
        address: 'Addresse',
        typeOfplace: 'Type de lieux',
        startingOn: 'Starting on',
        endingOn: 'Ending on',
        correspondence: 'Correspondence',
        residence: 'Residence',
        professionalDomicile: 'Professional Domicile',
        changeCorrespondenceType: 'Change correspondence type',
        changeYourCorrespondenceTo: 'Change correspondence type to',
        comingChange: 'Coming change',
        menu: {
          cancelCorrespondencePlaceChange: 'Cancel corespondence change',
        },
        cancelCorrespondencePlaceChange: {
          areYouSure: 'Are you sure you want to cancel the correspondence chnage',
        },
      },
    },
  },
};
